import { Spinner as SpinnerIcon } from "./spinner";

export function Spinner() {
  return (
    <div className="inline-flex items-center gap-2 text-sm text-muted-foreground">
      <SpinnerIcon />
      Chargement...
    </div>
  );
}
